__turbopack_context__.v({
  "app_light_theme": "CreditItem-module-scss-module__Ad_eeG__app_light_theme",
  "creditContentTab": "CreditItem-module-scss-module__Ad_eeG__creditContentTab",
  "creditContentTab__buttonWrap": "CreditItem-module-scss-module__Ad_eeG__creditContentTab__buttonWrap",
  "creditContentTab__footerNode": "CreditItem-module-scss-module__Ad_eeG__creditContentTab__footerNode",
  "creditContentTab__infoItem": "CreditItem-module-scss-module__Ad_eeG__creditContentTab__infoItem",
  "creditContentTab_withSeparate": "CreditItem-module-scss-module__Ad_eeG__creditContentTab_withSeparate",
});
